module.exports = __webpack_public_path__ + "static/wrike-bb8dfa59496260d6630194c42b417f31.svg";